import React from "react";
import MapNavIcon from "pages/OrdersMap/components/MapNavIcon";
export default function FloatingActionMenu({ actions }) {
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(prev => !prev)
  }

  return (
    <div className="z-[400] flex items-center space-x-0 pl-1">
      {actions.map((action, index) => (
        <MapNavIcon
          key={index}
          icon={action.icon}
          tooltipTitle={action.name}
          onClick={() => {
            action.handleClick();
          }}
        />
      ))}
    </div>
  );
}
